import { useCallback, useSyncExternalStore } from "react";

// Live result of a CSS media query, e.g. useMediaQuery("(min-width: 1024px)").
// Returns `fallback` where matchMedia does not exist (SSR, jsdom tests).
export default function useMediaQuery(query, fallback = false) {
  const subscribe = useCallback(
    (cb) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener("change", cb);
      return () => mql.removeEventListener("change", cb);
    },
    [query],
  );
  const get = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : fallback;
  return useSyncExternalStore(subscribe, get, () => fallback);
}
